{
  "name": "@owc/connection-tracking",
  "version": "2.9.0",
  "description": "SDK Connection Tracking",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "type": "module",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "publishConfig": {
    "scope": "@owc"
  },
  "scripts": {
    "test:dev": "vitest",
    "test": "vitest run --coverage",
    "build": "tsdown -c tsdown.config.ts",
    "dev": "concurrently \"rolldown -c rolldown.config.dev.ts --watch\" \"serve ./dist/\"",
    "lint:list": "eslint src/**/*.ts --fix --ignore-pattern '!node_modules/*'",
    "lint": "eslint src/**/*.ts --ignore-pattern '!node_modules/*'",
    "npmPublish": "npm publish",
    "precommit:lint": "lint-staged"
  },
  "keywords": [],
  "author": "",
  "license": "ISL",
  "dependencies": {
    "@seamless/logger": "7.5.0",
    "@seamless/store": "7.2.0"
  },
  "devDependencies": {
    "vitest": "^2.1.4",
    "@vitest/coverage-v8": "^2.1.8",
    "jsdom": "^25.0.1",
    "@gfx/zopfli": "1.0.15",
    "tsdown": "^0.15.12",
    "@seamless/config": "^8.0.0",
    "@seamless/eslint-config": "^9.1.0",
    "@seamless/logger": "7.5.0",
    "@seamless/store": "7.2.0",
    "concurrently": "^9.2.0",
    "eslint": "^9.39.0",
    "lint-staged": "^15.5.2",
    "prettier": "^3.6.2",
    "redux": "5.0.1",
    "serve": "^14.2.4",
    "typescript": "^5.9.2"
  }
}
